import { render, staticRenderFns } from "./applyBatch.vue?vue&type=template&id=75222e0c&scoped=true"
import script from "./applyBatch.vue?vue&type=script&lang=js"
export * from "./applyBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75222e0c",
  null
  
)

export default component.exports